import React from 'react';

export const KeySVG: JSX.Element = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      /* eslint-disable-next-line max-len */
      d="M8.82187 10.7406L7.75313 11.7531C7.64063 11.9219 7.45 12 7.25 12H6V13.25C6 13.6656 5.66563 14 5.25 14H4V15.25C4 15.6656 3.66563 16 3.25 16H0.75C0.335938 16 0 15.6656 0 15.25V12.75C0 12.55 0.0790312 12.3594 0.219656 12.2188L5.25938 7.17812C5.09063 6.65 5 6.08438 5 5.5C5 2.4625 7.4625 0 10.5 0C13.5375 0 16 2.4625 16 5.5C16 8.5375 13.5375 11 10.5 11C9.91562 11 9.35 10.9094 8.82187 10.7406ZM11.75 5.5C12.4406 5.5 13 4.94063 13 4.25C13 3.55937 12.4406 3 11.75 3C11.0594 3 10.5 3.55937 10.5 4.25C10.5 4.94063 11.0594 5.5 11.75 5.5Z"
      fill="#FFFFFF"
    />
  </svg>
);
